import React from 'react';
import RenderSource from './RenderSource';
import SessionRenderer from './sessionRenderer';
import AIAlertColumnRenderer from './AIAlertColumnRender';

export const getCellRenderer = (
  dataKey,
  column,
  rowData,
  cellData,
  alertsSessionAssociationValue,
  alertListValue,
) => {
  switch (dataKey) {
    case 'SessionId':
      return <SessionRenderer column={column} rowData={rowData} />;
    case 'Alert':
      return (
        <AIAlertColumnRenderer
          alertListValue={alertListValue}
          alertsSessionAssociationValue={alertsSessionAssociationValue}
          rowData={rowData}
        />
      );
    default:
      return <RenderSource data={cellData} dataKey={dataKey} />;
  }
};
